import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FilterConstants } from "src/app/constants/filterConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { CommonService } from "src/app/core/services/common.service";
import { TokenService } from "src/app/core/services/token.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { ExportHistoricoPlacaService } from "../export-historico-placa.service";

@Component({
  selector: "app-download-historico-placa",
  templateUrl: "./download-historico-placa.component.html",
  styleUrls: ["./download-historico-placa.component.sass"],
})
export class DownloadHistoricoPlacaComponent implements OnInit {
  public routing = RoutingConstants.exportarHistoricoPlaca;
  public downloadHistoricoPlaca;

  files = {
    ext1: ".xls",
  };

  filterList = FilterConstants.maintenanceHistoricoBastidor;

  constructor(
    private toastrAlertService: ToastrAlertService,
    private commonService: CommonService,
    private exportHistoricoPlacaService: ExportHistoricoPlacaService,
    private tokenService: TokenService,
    private sweetAlertService: SweetAlertService
  ) {}

  ngOnInit(): void {
    this.initFormGroup();
  }

  initFormGroup() {
    this.downloadHistoricoPlaca = new FormGroup({
      bastidor: new FormControl("", [Validators.maxLength(64)]),
      fechaInicio: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
      fechaFin: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
    });
  }

  onSubmit() {
    let filters = this.concatFiltersForSearch();
    let filterName = this.createFileName();

    if (this.downloadHistoricoPlaca.value.bastidor) {
      this.sweetAlertService.sweetAlertLoading();
      this.exportHistoricoPlacaService.getFile(filters).subscribe(
        (data) => {
          this.commonService.downloadFile(data, filterName);
          this.sweetAlertService.sweetAlertClose();
          this.goPredefinedMailBox();
        },
        (err) => {
          this.toastrAlertService.toastFailBlob(err.error);
          this.sweetAlertService.sweetAlertClose();
        }
      );
    } else {
      this.toastrAlertService.toastrFail("No bastidor especificado");
    }
  }

  concatFiltersForSearch(): string {
    let filters = "";
    if (this.downloadHistoricoPlaca.value.bastidor) {
      filters =
        filters + "?_bastidor=" + this.downloadHistoricoPlaca.value.bastidor;
    }
    if (this.downloadHistoricoPlaca.value.fechaInicio) {
      filters =
        filters +
        "&_fechaInicio=" +
        this.downloadHistoricoPlaca.value.fechaInicio;
    }
    if (this.downloadHistoricoPlaca.value.fechaFin) {
      filters =
        filters + "&_fechaFin=" + this.downloadHistoricoPlaca.value.fechaFin;
    }
    return filters;
  }

  createFileName(): string {
    let retFileName = "HistoricoPlaca";
    if (this.downloadHistoricoPlaca.value.bastidor) {
      retFileName =
        retFileName + "_Bastidor-" + this.downloadHistoricoPlaca.value.bastidor;
    }
    if (this.downloadHistoricoPlaca.value.fechaInicio) {
      retFileName =
        retFileName +
        "_FechaInicio-" +
        this.downloadHistoricoPlaca.value.fechaInicio;
    }
    if (this.downloadHistoricoPlaca.value.fechaFin) {
      retFileName =
        retFileName + "_FechaFin-" + this.downloadHistoricoPlaca.value.fechaFin;
    }
    retFileName = retFileName + this.files.ext1;
    return retFileName;
  }

  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }
}
